var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { class: ["simple-progress-bar-container", _setup.props.status] },
    [
      _c("div", { staticClass: "info-container" }, [
        _c("div", { staticClass: "info-container-item" }, [
          _setup.props.icon
            ? _c("span", {
                class: ["info-container-item-icon", _setup.props.icon],
              })
            : _vm._e(),
          _c("span", { staticClass: "info-container-item-text" }, [
            _vm._v(_vm._s(_setup.props.text)),
          ]),
        ]),
      ]),
      _c("v-progress-linear", {
        attrs: {
          indeterminate: _setup.computedIndeterminate,
          rounded: "",
          color: _setup.vars.progress_bar_success,
          "background-color": _setup.computedBackgroundColor,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }